import React, { useEffect, useState } from "react";
import { useTranslation } from 'react-i18next';
import { GetProfileOrganisations } from "../../api/orgs";
import { Loader } from "../../components/Loader";
import { Organisation } from "../../models/organisation/OrganisationModelV2";
import "./Admin.css";
import { client } from "../..";
import { useNavigate } from "react-router-dom";

export const Admin: React.FC = () => {

    const { t } = useTranslation();
    const navigate = useNavigate()

    const [loading, setLoading] = useState<boolean>()

    const [companies, setCompanies] = useState<Organisation[]>([])

    const CompaniestHeader = () => {
        return <tr>
            <th>{t('name')}</th>
            <th>{t('location')}</th>
            <th>{t('province')}</th>
        </tr>
    }

    const CompaniestRow = (company: Organisation, onCompanyClick) => {
        return <tr className="hoverGreenPale" style={{ cursor: "pointer" }} key={company.id} onClick={() => {
            onCompanyClick(company)
        }}>
            <td>{company.name}</td>
            <td>{company?.location?.village}</td>
            <td>{company?.location?.province}</td>
        </tr>
    }

    useEffect(() => {
        setLoading(true)
        const fetchCompanies = () => {
            client.query({
                query: GetProfileOrganisations,
                context: {
                    headers: {
                        "role": "usermill"
                    }
                }
            }).then(result => {
                const orgs: Organisation[] = (result.data.profile.profile.organisations ?? [])
                    .filter(o => o.type === "conglomerate" && !o.deleted_at)
                    .map(o => Organisation.build(o))
                orgs.sort((orgA, orgB) => { return orgA.name.localeCompare(orgB.name) })
                setCompanies(orgs)
            }).finally(() => {
                setLoading(false)
            })
        }
        fetchCompanies()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const onOrgClick = (org: any) => {
        navigate(`/explorer/company_admin_detail/${org.id}`)
    }

    return (
        <div style={{ width: "100%", display: "flex", flexDirection: "column" }}>
            <h1>{t('admin')}</h1>
            <div style={{ display: "flex", flexDirection: "row" }}>
                <table className="pem-table" style={{ flex: "1", margin: "0px 20px 0px 28px" }}>
                    <thead>
                        {CompaniestHeader()}
                    </thead>
                    <tbody>
                        {companies.map((company) => CompaniestRow(company, (company) => { onOrgClick(company) }))}
                    </tbody>
                </table>
            </div>
            <Loader isLoading={loading} />
        </div>
    )
}